import { a as EditorClientPlugin, b as BdHiJsClientPlugin } from "./BdHiJs-BoUJUuIZ.js";
const ClientPlugins = [
  EditorClientPlugin,
  BdHiJsClientPlugin
];
export {
  ClientPlugins
};
//# sourceMappingURL=client.es.js.map
